import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import queryString from 'query-string'
import _ from 'lodash'

import {
  authenticateTokenLoginIntegrado,
  recuperarLoginUsuarioCorrente
} from '../actions/authenticationJwtActions'

class SSO extends Component {
  componentDidMount() {
    const { username, token } = this.props.match.params
    if (username && token) {
      this.props.authenticateTokenLoginIntegrado(username, token)
    } else {
      const query = queryString.parse(this.props.location.search)
      const tkn = query.tkn
      if (tkn) {
        this.props.authenticateTokenLoginIntegrado(null, tkn, query.origin)
      }
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { authentication: prevAuthentication } = prevProps
    const { authentication } = this.props
    if (
      authentication != null &&
      authentication !== prevAuthentication &&
      authentication.isUserAuthenticated
    ) {
      const { username } = authentication
      if (!username) {
        this.props.recuperarLoginUsuarioCorrente()
      } else {
        const query = queryString.parse(this.props.location.search)
        const { redirectTo, ...params } = query
        if (redirectTo) {
          let to = redirectTo
          _.forEach(_.entries(params), ([key, value]) => {
            if (to.indexOf('?') === -1) {
              to = to.concat(`?${key}=${value}`)
            } else {
              to = to.concat(`&${key}=${value}`)
            }
          })
          this.props.history.replace(to)
        } else {
          this.props.history.replace('/')
        }
      }
    }
  }

  render() {
    return <div />
  }
}

const mapStateToProps = ({ authentication }) => ({ authentication })

const reduxEnhanced = connect(mapStateToProps, {
  authenticateTokenLoginIntegrado,
  recuperarLoginUsuarioCorrente
})(SSO)

export default withRouter(reduxEnhanced)
